import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["quizAnalysis", "itemAnalyses", "fetchInProgress", "generationInProgress", "analysisError", "setQuizAnalysis", "addError", "setItemAnalyses", "setFetchInProgress", "setGenerationInProgress", "setAnalysisError", "activeQuizId", "generateAnalysis", "fetchQuizAnalysis", "fetchItemAnalyses", "getAnalysesExport", "fetchAnalysesStatus", "statusPollingInProgress", "setStatusPollingInProgress", "pollingInterval", "disableReportsCache"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { itemAnalysisPropType, quizAnalysisPropType } from '../common/propTypes';
import { fetchReports } from './fetchReports';
import { fetchReportsStatus } from './fetchReportsStatus';
import { getErrorMessageForCode } from '../common/errorCodes';
import { generateReports as triggerReportGeneration } from '../common/generateReports';
import { exportReports as triggerExportReports } from '../common/exportReports';
import { saveFile } from '../common/utils';
export var withAnalysisStatePresenter = function withAnalysisStatePresenter(OriginalComponent) {
  var _WithAnalysisStatePresenter = function WithAnalysisStatePresenter(_ref) {
    var quizAnalysis = _ref.quizAnalysis,
      itemAnalyses = _ref.itemAnalyses,
      fetchInProgress = _ref.fetchInProgress,
      generationInProgress = _ref.generationInProgress,
      analysisError = _ref.analysisError,
      setQuizAnalysis = _ref.setQuizAnalysis,
      addError = _ref.addError,
      setItemAnalyses = _ref.setItemAnalyses,
      setFetchInProgress = _ref.setFetchInProgress,
      setGenerationInProgress = _ref.setGenerationInProgress,
      setAnalysisError = _ref.setAnalysisError,
      activeQuizId = _ref.activeQuizId,
      generateAnalysis = _ref.generateAnalysis,
      fetchQuizAnalysis = _ref.fetchQuizAnalysis,
      fetchItemAnalyses = _ref.fetchItemAnalyses,
      getAnalysesExport = _ref.getAnalysesExport,
      fetchAnalysesStatus = _ref.fetchAnalysesStatus,
      statusPollingInProgress = _ref.statusPollingInProgress,
      setStatusPollingInProgress = _ref.setStatusPollingInProgress,
      pollingInterval = _ref.pollingInterval,
      disableReportsCache = _ref.disableReportsCache,
      passThroughProps = _objectWithoutProperties(_ref, _excluded);
    _WithAnalysisStatePresenter.displayName = "WithAnalysisStatePresenter(".concat(OriginalComponent.displayName || OriginalComponent.name, ")");
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      analysisFetchError = _useState2[0],
      setAnalysisFetchError = _useState2[1];
    var instrumentedFetchReports = function instrumentedFetchReports() {
      return fetchReports({
        activeQuizId: activeQuizId,
        addError: addError,
        fetchQuizAnalysis: fetchQuizAnalysis,
        fetchItemAnalyses: fetchItemAnalyses,
        setAnalysisError: setAnalysisError,
        setStatusPollingInProgress: setStatusPollingInProgress,
        setItemAnalyses: setItemAnalyses,
        setGenerationInProgress: setGenerationInProgress,
        setFetchInProgress: setFetchInProgress,
        setQuizAnalysis: setQuizAnalysis,
        getErrorMessageForCode: getErrorMessageForCode,
        setAnalysisFetchError: setAnalysisFetchError
      });
    };
    var instrumentedStatusFetching = function instrumentedStatusFetching() {
      return fetchReportsStatus({
        activeQuizId: activeQuizId,
        addError: addError,
        setGenerationInProgress: setGenerationInProgress,
        setStatusPollingInProgress: setStatusPollingInProgress,
        fetchAnalysesStatus: fetchAnalysesStatus,
        instrumentedFetchReports: instrumentedFetchReports
      });
    };
    function generateReports() {
      return _generateReports.apply(this, arguments);
    }
    function _generateReports() {
      _generateReports = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var filter,
          generationConfig,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              filter = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'last_attempt';
              generationConfig = {
                filter: filter,
                generateAnalysis: generateAnalysis,
                setGenerationInProgress: setGenerationInProgress,
                setStatusPollingInProgress: setStatusPollingInProgress,
                addError: addError
              };
              _context3.next = 4;
              return triggerReportGeneration(generationConfig);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _generateReports.apply(this, arguments);
    }
    function exportReports(_x) {
      return _exportReports.apply(this, arguments);
    }
    function _exportReports() {
      _exportReports = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(format) {
        var filter,
          exportConfig,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              filter = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 'last_attempt';
              exportConfig = {
                getAnalysesExport: getAnalysesExport,
                format: format,
                filter: filter,
                activeQuizId: activeQuizId,
                addError: addError,
                saveFile: saveFile
              };
              _context4.next = 4;
              return triggerExportReports(exportConfig);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _exportReports.apply(this, arguments);
    }
    useEffect(function () {
      var fetchIfNeeded = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var hasStoredAnalyses;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                hasStoredAnalyses = quizAnalysis && itemAnalyses;
                if (!(!hasStoredAnalyses || disableReportsCache)) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return instrumentedFetchReports();
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function fetchIfNeeded() {
          return _ref2.apply(this, arguments);
        };
      }();
      fetchIfNeeded();
    }, []);
    var _recursiveInstrumentedStatusFetching = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isReportGenerationReady;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instrumentedStatusFetching();
            case 2:
              isReportGenerationReady = _context2.sent;
              !isReportGenerationReady && setTimeout(_recursiveInstrumentedStatusFetching, pollingInterval);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function recursiveInstrumentedStatusFetching() {
        return _ref3.apply(this, arguments);
      };
    }();
    useEffect(function () {
      statusPollingInProgress && _recursiveInstrumentedStatusFetching();
    }, [statusPollingInProgress]);
    return /*#__PURE__*/React.createElement(OriginalComponent, Object.assign({
      quizAnalysis: quizAnalysis,
      itemAnalyses: itemAnalyses,
      fetchInProgress: fetchInProgress,
      generationInProgress: generationInProgress,
      analysisError: analysisError,
      generateReports: generateReports,
      exportReports: exportReports,
      analysisFetchError: analysisFetchError
    }, passThroughProps));
  };
  _WithAnalysisStatePresenter.propTypes = {
    quizAnalysis: quizAnalysisPropType,
    itemAnalyses: PropTypes.arrayOf(itemAnalysisPropType),
    fetchInProgress: PropTypes.bool.isRequired,
    generationInProgress: PropTypes.bool.isRequired,
    statusPollingInProgress: PropTypes.bool.isRequired,
    analysisError: PropTypes.string,
    setQuizAnalysis: PropTypes.func.isRequired,
    setItemAnalyses: PropTypes.func.isRequired,
    setFetchInProgress: PropTypes.func.isRequired,
    setGenerationInProgress: PropTypes.func.isRequired,
    setAnalysisError: PropTypes.func.isRequired,
    setStatusPollingInProgress: PropTypes.func.isRequired,
    activeQuizId: PropTypes.string.isRequired,
    fetchQuizAnalysis: PropTypes.func.isRequired,
    fetchItemAnalyses: PropTypes.func.isRequired,
    fetchAnalysesStatus: PropTypes.func.isRequired,
    getAnalysesExport: PropTypes.func.isRequired,
    addError: PropTypes.func.isRequired,
    pollingInterval: PropTypes.number.isRequired,
    generateAnalysis: PropTypes.func.isRequired,
    // from LTI, f(filter: string, onError?: func(error))
    disableReportsCache: PropTypes.bool
  };
  _WithAnalysisStatePresenter.defaultProps = {
    quizAnalysis: void 0,
    itemAnalyses: void 0,
    analysisError: '',
    disableReportsCache: false
  };
  return _WithAnalysisStatePresenter;
};